import UsersListPageContainer from "../../components/users/usersList";



const Users = () => {
 

  return <UsersListPageContainer />;
};
export default Users;
